import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let IconSideBase = class IconSideBase extends Vue {
    color;
    width;
    height;
    alpha;
};
__decorate([
    Prop(String)
], IconSideBase.prototype, "color", void 0);
__decorate([
    Prop({ default: '26', type: String })
], IconSideBase.prototype, "width", void 0);
__decorate([
    Prop({ default: '18', type: String })
], IconSideBase.prototype, "height", void 0);
__decorate([
    Prop({ default: '1', type: String })
], IconSideBase.prototype, "alpha", void 0);
IconSideBase = __decorate([
    Component({
        name: 'iconSideBase',
    })
], IconSideBase);
export default IconSideBase;
